import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import IntroContentEn from "./IntroContentEn";
import IntroContentFr from "./IntroContentFr";
import IntroContentAr from "./IntroContentAr";
import DownloadAppSection from "./DownloadAppSection";

function IntroPage() {
  const {i18n} = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <header>
        <NavBar />
      </header>
      {lang === "fr" 
      ? <IntroContentFr /> 
      :lang === "ar" 
        ? <IntroContentAr /> 
        : <IntroContentEn />}
      <DownloadAppSection />
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default IntroPage;
